define([], function () {
    return document.location.host.indexOf("admin") !== -1;
});
